import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CreateSecretPage } from "./routes/CreateSecretPage";
import { RetrieveSecretPage } from "./routes/RetrieveSecretPage";
import { ReplyPage } from "./routes/ReplyPage";
import { AuthGate } from "./components/AuthGate";
import { LanguagePicker } from "./components/LanguagePicker";
import { useI18n } from "./i18n";
import { APP_NAME, APP_TAGLINE, LOGO_URL } from "./lib/config";

export default function App() {
  const { m } = useI18n();

  return (
    <BrowserRouter>
      <div className="app-shell">
        <header className="app-header">
          {/* Name, tagline and logo are the operator's brand — never translated. */}
          <a href="/" className="app-title">
            {LOGO_URL ? <img src={LOGO_URL} alt={APP_NAME} className="app-logo" /> : APP_NAME}
          </a>
          <span className="app-subtitle">{APP_TAGLINE}</span>
          <span className="app-header-spacer" />
          <span className="app-header-caption">{m.header.encrypted}</span>
          <LanguagePicker />
        </header>
        <main className="app-main">
          <Routes>
            <Route
              path="/"
              element={
                <AuthGate>
                  <CreateSecretPage />
                </AuthGate>
              }
            />
            <Route path="/s/:id" element={<RetrieveSecretPage />} />
            {/*
              Outside AuthGate on purpose. A reply grant is the credential
              here, and it belongs to someone who by definition cannot sign
              in — see routes/ReplyPage.tsx. With no grant the page says so
              rather than composing anything.
            */}
            <Route path="/reply" element={<ReplyPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
